export default class PageResultModel {

  page: number;
  pageSize: number;
  total: number;
  filterCriteria: any;
  results: any[];

  constructor(serverPageResult: any, results: any[]) {

    this.page = serverPageResult.page;
    this.pageSize = serverPageResult.pageSize;
    this.total = serverPageResult.total;
    this.filterCriteria = serverPageResult.filterCriteria;
    this.results = results;
  }
}
